<template>
  <tr>
    <td :colspan="columns.length">
      <v-expansion-panels v-if="childTables.length > 1">
        <v-expansion-panel
          v-for="child in childTables"
          :key="child.id"
          :title="child.id"
        >
          <v-expansion-panel-text>
            <TableComponentGeneric :table="child" hide-pagination />
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
      <TableComponentGeneric
        v-else-if="childTables.length > 0"
        :table="childTables[0]"
        hide-pagination
      />
    </td>
  </tr>
</template>
<script lang="ts" setup>
import { ChildTablesType } from "@/composables/useTableHelper";
import { createTableComponent } from "./ReportingTableContents";
const TableComponentGeneric = createTableComponent<any, any>();
const props = defineProps<{ childTables: ChildTablesType; columns: any[] }>();
</script>
